<script lang="ts" generics="TValues">
    import type { Field, Form } from '@jmvdevelop/svelte-form';
    import Input from '$components/Form/Input.svelte';
    import { cx } from '$lib/utils/cx';

    export let form: Form<TValues, string>;
    export let field: Field<TValues, string>;
    export let name: string | undefined = undefined;

    let className: string = '';
    export { className as class };

    let type: 'password' | 'text' = 'password';

    function onToggleClick() {
        if (type === 'password') {
            type = 'text';
        } else {
            type = 'password';
        }
    }
</script>

<div class={cx(className, 'relative isolate')}>
    <Input {form} {field} {name} toText={(id) => id} fromText={(id) => id} {type} />
    <div class="absolute top-0 bottom-0 right-0 flex items-center pr-4">
        <button
            class="btn btn-gray outline-none focus:ring-brand-blue focus:ring-2 focus:border-transparent"
            type="button"
            on:click|preventDefault={onToggleClick}
        >
            <i class="fa fa-eye" aria-hidden="true"></i>
            <span class="sr-only">Montrer</span>
        </button>
    </div>
</div>
